// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sort-by-arrow {
  float: right;
  margin-right: 1rem;
}
.sort-by-arrow:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Table/TableSort.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;AACF;AAAE;EACE,eAAA;AAEJ","sourcesContent":[".sort-by-arrow {\n  float: right;\n  margin-right: 1rem;\n  &:hover {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
